import requestAction from '../../utils/requestAction'
import Notification from '../../models/Notification';

export const upsertNotification = (notification: Notification, handleResponse?: (notificationId: number) => void) =>
  requestAction('NOTIFICATION_UPSERT')(
    `notifications${notification.id ? `/${notification.id}` : ''}`,
    notification.id ? 'PUT' : 'POST',
    notification,
    undefined,
    undefined,
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response.notificationId) })

